<template>
  <div class="modal fade" id="myModal2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-subscription">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body">
          <template v-if="showResetPass">
            <form @submit.prevent="forgetPassword">
              <h3 style="font-weight: bold;">Recuperar Contraseña</h3>
              <input name="utf8" type="hidden" value="✓" />
              &nbsp;
              <div class="form-group">
                <div class="row">
                  <div class="col-sm-2" style="text-align: left;">
                    <label for="exampleFormControlSelect1"><strong>Correo</strong></label>
                  </div>
                  <div class="col-sm-10">
                    <input
                      v-model="formUsername"
                      placeholder="E-mail"
                      class="form-control"
                      type="email"
                    />
                  </div>
                </div>
              </div>
              <template v-if="loadingResetPass">
                Cargando... por favor, espere
              </template>

              &nbsp;
              <div class="mimi_field">
                <input
                  type="submit"
                  class="submit btn-al btn-al-lg btn-al-celeste-solid btn-secciones button-left-subscription"
                  value="Reestablecer"
                  id="webform_submit_button"
                />
                <button
                  type="button"
                  @click="setResetPassFalse()"
                  class="btn-al btn-al-lg btn-al-azul-solid btn-secciones button-right-subscription"
                >
                  Volver</button
                >&nbsp;
              </div>
            </form>
          </template>
          <template v-else>
            <form @submit.prevent="login">
              <h3 style="font-weight: bold;">Iniciar Sesión</h3>
              <input name="utf8" type="hidden" value="✓" />
              &nbsp;
              <div class="form-group">
                <div class="row">
                  <div class="col-sm-2" style="text-align: left;">
                    <label for="exampleFormControlSelect1"><strong>Correo</strong></label>
                  </div>
                  <div class="col-sm-10">
                    <input
                      v-model="formUsername"
                      placeholder="E-mail o nombre de usuario"
                      class="form-control"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-sm-2" style="text-align: left;">
                    <label for="exampleFormControlSelect1"><strong>Clave</strong></label>
                  </div>
                  <div class="col-sm-10">
                    <input
                      v-model="formPassword"
                      placeholder="Contraseña"
                      class="form-control"
                      type="password"
                    />
                  </div>
                </div>
              </div>
              <p class="text-muted">
                <span>
                  <a href="#" @click="setResetPassTrue()">¿Olvidaste tu contraseña?</a>
                </span>
              </p>
              &nbsp;

              <div class="mimi_field">
                <input
                  type="submit"
                  class="submit btn-al btn-al-lg btn-al-celeste-solid btn-secciones button-left-subscription"
                  value="Acceder"
                  id="webform_submit_button"
                />
                <button
                  type="button"
                  class="btn-al btn-al-lg btn-al-azul-solid btn-secciones button-right-subscription"
                  data-dismiss="modal"
                >
                  Cerrar</button
                >&nbsp;
              </div>
            </form>
            <!--
            <fb-signin-button
              :params="fbSignInParams"
              @success="onSignInFbSuccess"
              @error="onSignInFbError"
            >
              Inicia Sesión con Facebook
            </fb-signin-button>
            -->
            <br />
            <div
              style="display: flex; justify-content: center"
              id="google-login-btn"
              v-google-identity-login-btn="{ clientId }"
            >
              Inicia Sesión con google
            </div>
          </template>
          <div class="form-group text-center">
            <br />
            <p data-dismiss="modal">
              Si aún no posee una cuenta puede registrarse
              <router-link to="/registrar">aquí</router-link>.
            </p>
          </div>
          <br />
          <template v-if="loadingBar">
            <div class="col-xs-12 text-center">
              <div class="progress">
                <div
                  class="progress-bar progress-bar-striped active"
                  role="progressbar"
                  aria-valuenow="100"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 100%"
                ></div>
              </div>
            </div>
          </template>
          <div :class="[loginMessage === '' ? 'd-none' : 'alert alert-success']" role="alert">
            <button type="button" class="close" data-dismiss="alert" @click="hideMessages()">
              &times;</button
            ><strong>{{ loginMessage }}</strong>
          </div>
          <div :class="[errorLoginMessage === '' ? 'd-none' : 'alert alert-danger']" role="alert">
            <button type="button" class="close" data-dismiss="alert" @click="hideMessages()">
              &times;</button
            ><strong>{{ errorLoginMessage }}</strong>
          </div>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  generateTokenBodyRequest,
  generateTokenBodywFacebookRequest,
  generateTokenBodywGoogleRequest,
  setOauth2TypeUser,
  setTokens,
} from '@/helpers/localStorage.helpers';
import { postLogin, postNewAccount, putPassword } from '@/service/account.service';
import { NOT_FOUND, BAD_REQUEST, CONFLICT } from '@/types/httpd.constants';
import GoogleSignInButton from 'vue-google-identity-login-btn';

export default {
  name: 'LoginModal',
  directives: {
    GoogleSignInButton,
  },
  data() {
    return {
      fbSignInParams: {
        scope: 'user_birthday,user_hometown,user_location,user_photos,email',
        return_scopes: true,
      },
      clientId: '489000419563-22jhklr2fhat037dpurh9tq8g5u4j0ts.apps.googleusercontent.com',
      formUsername: '',
      formPassword: '',
      loginMessage: '',
      errorLoginMessage: '',
      showResetPass: false,
      loadingResetPass: false,
      loadingBar: false,
      facebookProfileData: {},
      googleProfileData: {},
    };
  },
  methods: {
    hideMessages() {
      this.loginMessage = '';
      this.errorLoginMessage = '';
    },

    setResetPassTrue() {
      this.showResetPass = true;
    },

    setResetPassFalse() {
      this.showResetPass = false;
    },

    registerUser(json_data, origin, thirdPartieToken) {
      postNewAccount(json_data, origin)
        .then((response) => {
          if (origin === 'google') {
            this.onGoogleAuthSuccess(thirdPartieToken);
          } else if (origin === 'facebook') {
            const body = generateTokenBodywFacebookRequest(
              json_data.email_client,
              thirdPartieToken,
            );
            this.sendDataToGenerateToken(body, 'facebook', thirdPartieToken);
          }
        })
        .catch((error) => {
          this.loadingBar = false;
          if (error.response.status === CONFLICT) {
            this.errorLoginMessage =
              'El nombre de usuario o el e-mail que desea registrar ya existe en la base de datos.';
          } else if (error.response.status === BAD_REQUEST) {
            this.errorLoginMessage = 'Ingrese correctamente los datos solicitados.';
          } else if (error.response.status === NOT_FOUND) {
            this.errorLoginMessage = 'Se ha producido un error. Inténtelo nuevamente.';
          }
          this.loginMessage = '';
        });
    },

    createAccountFromGoogle(googleDataObject, googleToken) {
      var arrayDeCadenas = googleDataObject.email.split('@');
      var json_data = {
        nick_client: arrayDeCadenas[0],
        dni_client: null,
        name_client: googleDataObject.given_name,
        surname_client: googleDataObject.family_name,
        address_client: '',
        email_client: googleDataObject.email,
        phone_client: null,
        id_district: { id_district: null },
        state: {
          id_state: 1,
        },
        password_client: 'password',
        photo_client: googleDataObject.picture,
      };
      this.registerUser(json_data, 'google', googleToken);
    },

    createAccountFromFacebook(facebookDataObject, fbToken) {
      var arrayDeCadenas = facebookDataObject.email.split('@');
      var json_data = {
        nick_client: arrayDeCadenas[0],
        dni_client: null,
        name_client: facebookDataObject.first_name,
        surname_client: facebookDataObject.last_name,
        address_client: '',
        email_client: facebookDataObject.email,
        phone_client: null,
        id_district: { id_district: null },
        state: {
          id_state: 1,
        },
        password_client: 'password',
        photo_client: '',
      };
      this.registerUser(json_data, 'facebook', fbToken);
    },

    sendDataToGenerateToken(body, origin, thirdPartieToken) {
      this.loadingBar = true;
      postLogin(body)
        .then((response) => {
          this.loginMessage = 'Sesión Iniciada correctamente. Se están cargando sus datos...';
          setTokens(response.data.access_token, response.data.refresh_token);
          setOauth2TypeUser(origin);
          this.loadingBar = false;
          location.reload();
        })
        .catch((error) => {
          if (origin === 'internal') {
            this.loadingBar = false;
            this.errorLoginMessage =
              'Clave y/o usuario no coinciden. Ingrese nuevamente su usuario y contraseña.';
          } else if (origin === 'facebook') {
            this.createAccountFromFacebook(this.facebookProfileData, thirdPartieToken);
          } else if (origin === 'google') {
            this.createAccountFromGoogle(this.googleProfileData, thirdPartieToken);
          }
        });
    },

    login() {
      const body = generateTokenBodyRequest(this.formUsername, this.formPassword);
      this.sendDataToGenerateToken(body, 'internal', '');
    },

    forgetPassword() {
      this.showResetPass = true;
      this.loadingResetPass = true;
      var json_data = {
        cli_username: this.formUsername,
      };
      putPassword(json_data)
        .then((response) => {
          this.loadingResetPass = false;
          this.showResetPass = false;
          this.loginMessage =
            '¡Exito! Su contraseña ha sido restablecida correctamente. Por favor, verifique su correo electrónico.';
          this.formUsername = '';
          this.formPassword = '';
        })
        .catch((error) => {
          this.loadingResetPass = false;
          this.loginMessage = '';
          this.errorLoginMessage =
            'Hubo un problema al generar la nueva contraseña. Verifique si ingreso su usuario correctamente e intentelo nuevamente.';
        });
    },

    onSignInFbSuccess(response) {
      FB.api(
        '/me?fields=birthday,email,first_name,hometown,id,inspirational_people,install_type,is_guest_user,last_name',
        (dude) => {
          this.facebookProfileData = dude;
          const fbToken = response.authResponse.accessToken;
          const body = generateTokenBodywFacebookRequest(dude.email, fbToken);
          this.sendDataToGenerateToken(body, 'facebook', fbToken);
        },
      );
    },

    onSignInFbError(error) {
      console.log('Facebook no válido', error);
    },

    onGoogleAuthSuccess(jwtCredentials) {
      const profileData = JSON.parse(atob(jwtCredentials.split('.')[1]));
      this.googleProfileData = profileData;
      const body = generateTokenBodywGoogleRequest(profileData.email, jwtCredentials);
      this.sendDataToGenerateToken(body, 'google', jwtCredentials);
    },
  },
};
</script>

<style></style>
